<template>
  <frontoffice-frame>
    <b-container v-if="!isLoaded" class="loader-section">
      <frontoffice-loader />
    </b-container>

    <div
      v-else
      id="page"
      class="front-layout"
      :class="companyUid ? 'booking-unlogged' : ''"
    >
      <headbar v-if="companyUid" class="headbar" :logo="logo" />

      <b-container v-if="isLoaded" class="offline-booking-form">
        <offline-booking-form
          :is-generic="isGeneric"
          :generic-infos="genericInfos"
        />
      </b-container>
    </div>
  </frontoffice-frame>
</template>

<script>
import headbar from "@/components/frontoffice/header";
import frontofficeFrame from "@/components/frontoffice/frame";
import frontofficeLoader from "@/components/frontoffice/loader";
import OfflineBookingForm from "@/components/frontoffice/OfflineBooking/OfflineBookingForm";
import CommonApi from "@/api/commonApi";

export default {
  components: {
    headbar,
    frontofficeFrame,
    frontofficeLoader,
    OfflineBookingForm,
  },

  data() {
    return {
      isLoaded: false,
      commonApi: new CommonApi(),
      companyUid: this.$route.params.companyUid || false,
      genericInfos: null,
      logo: null,
    };
  },

  created() {
    if (this.companyUid) {
      this.commonApi
        .getUnloggedCompanyData(this.companyUid)
        .then((response) => {
          if (response.data.success) {
            let data = response.data.data;

            this.genericInfos = {
              companyInputFields: data.inputFields,
              companyUniqueChain: data.uniqueChain,
              onlyOne: data.onlyOne,
              mealContribution: data.mealContribution,
            };

            this.logo = data.logo;
          }
        })
        .then(() => {
          this.testDataAvailability();
        })
        .then(() => {
          this.isLoaded = true;
        });
    } else {
      this.isLoaded = true;
    }
  },

  methods: {
    testDataAvailability() {
      if (this.isGeneric) return;

      let data = this.$store.getters["research/form"];
      let redirect = false;

      // Priority to Hotel
      if (data.favorite.hotel === null) {
        // Then location
        if (data.favorite.location === null) {
          // Then destination
          if (data.destination === null) {
            redirect = true;
          }
        }
      }

      if (data.bedrooms.single + data.bedrooms.double === 0) redirect = true;

      if (data.dates.from === null || data.dates.to === null) redirect = true;

      if (redirect) this.$router.push({ name: "home_search" });
    },
  },

  computed: {
    isGeneric() {
      return this.companyUid !== null && this.genericInfos !== null;
    },
  },
};
</script>
